import { Link } from 'react-router-dom';

export default function SettingsPage() {
  return (
    <>
      <h2 className="text-2xl font-semibold mb-4 text-blue-600">Settings</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Link
          to="/settings/mybussiness"
          className="block p-4 bg-white rounded-lg shadow hover:shadow-md hover:bg-blue-50 transition"
        >
          <h3 className="text-lg font-semibold text-blue-600 mb-2">Bussiness details</h3>
          <p className="text-gray-500">Add details.</p>
        </Link>
      </div>
    </>
  );
}
